import { usePageContext } from '~/contexts/page-context'
import { filterExcludedProviders, getProvidersByScope } from '~/utils/providers'
import { PROVIDERS } from '~/utils/providers-listing'

import InputForm from './components/input-form'

const LandingForm = ({ ctaText, variant, providersUnderlay = false, addressUnderlay = false }) => {
  const { scope } = usePageContext()

  const broadbandProviders = PROVIDERS.filter(({ connectionTypes }) => !connectionTypes.includes('BUSINESS'))
  const filteredProviders = filterExcludedProviders(broadbandProviders, 'XLN Telecom')

  const providersData = getProvidersByScope(filteredProviders, scope)

  return (
    <div>
      <InputForm
        ctaText={ctaText}
        variant={variant}
        addressUnderlay={addressUnderlay}
        providersData={providersData}
        providersUnderlay={providersUnderlay}
      />
    </div>
  )
}

export default LandingForm
